<template>
  <el-dialog
      :visible.sync="visible"
      title="填写发票号"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="100px"
    >
      <el-form-item label="发票号：" prop="receiptCode" label-width="80px">
        <el-input v-model="dataForm.receiptCode"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="save()">{{
          $t('confirm')
        }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
//销售开票填写发票号弹窗
export default {
  name: 'receipt-dialog',
  data () {
    return {
      dataForm: {
        id:'',
        receiptCode:''
      },
      visible: false,
      dataRule: {
        receiptCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
        ]
      },
    }
  },
  methods: {
    init (id) {
      this.dataForm.id = id
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
      })
    },
    cancel () {
      this.visible = false
    },
    save () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.post(`/trade/boxform/receipt`, this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$emit('refreshDataList')
          this.$message.success('保存成功')
          this.cancel()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
